var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkInfluencerBlueIconCommandcenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 19.079,
    viewBox: "0 0 20 19.079",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157171",
    "data-name": "Rectangle 157171",
    width: 20,
    height: 19.079,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mark_influencer_blue_icon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73752",
    "data-name": "Path 73752",
    d: "M19.971,7.245a.586.586,0,0,0-.473-.4l-6.2-.9L10.525.327a.586.586,0,0,0-1.051,0L6.7,5.945l-6.2.9a.586.586,0,0,0-.325,1l4.486,4.373L3.6,18.394a.586.586,0,0,0,.578.685h11.64a.586.586,0,0,0,.577-.685l-1.059-6.175,4.486-4.373a.586.586,0,0,0,.149-.6ZM10,6.605a2.472,2.472,0,1,1-1.745.724A2.469,2.469,0,0,1,10,6.605Zm-4.312,11.3a4.352,4.352,0,0,1,8.624,0Z",
    fill: "#6a8eff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkInfluencerBlueIconCommandcenter);
export default __webpack_public_path__ + "static/media/mark_influencer_blue_icon_commandcenter.ffaaf1692c2bc851107462add21635f0.svg";
export { ForwardRef as ReactComponent };